export default __webpack_public_path__ + "static/media/countdown.b5ebed72.mp4";